<div
  class="il"
  role="button"
  tabindex="0"
  data-testid="image-lightbox"
  cdkTrapFocus
  [attr.aria-label]="'imageLightbox.close' | translate"
  [cdkTrapFocusAutoCapture]="true"
  (click)="closed.emit()"
  (keydown.enter)="closed.emit()"
  (keydown.escape)="closed.emit()"
>
  <img class="il__img" [src]="url()" [alt]="alt()" />
</div>
